import { subscribeSwConfigReady } from 'services/serviceWorker/swConfigReady';
import { classifyEntityEvent } from './model';
import { EntityEventReaction, type RelatedEntityClient } from './types';

/**
 * Calls `onChange` after changes of the entity and when the worker's config is
 * ready again (a read that failed transiently, e.g. while the worker
 * restarted, is retried). Returns the unsubscribe.
 */
export function subscribeToEntityChanges(client: RelatedEntityClient, onChange: () => void): () => void {
  const stopEvents = client.onEvent((event) => {
    if (classifyEntityEvent(event, client.readCollection).reaction === EntityEventReaction.reload) {
      onChange();
    }
  });
  const stopConfigReady = subscribeSwConfigReady(onChange);
  return (): void => {
    stopEvents();
    stopConfigReady();
  };
}
